import React, { useRef, useState } from "react";
import "./loginSignupPage.css";
import InputBox from "../commonComponents/inputComponents/InputBox";

import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";

import Loader from "../commonComponents/Loader/Loader";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function LoginPage() {
  const [isLoading, setIsLoading] = useState(false);

  const phoneRef = useRef();
  const passRef = useRef();

  const { login } = useAuth();
  const navigate = useNavigate();

  async function handleLogin(e) {
    e.preventDefault();
    setIsLoading(true);
    const phoneNumber = phoneRef.current.value;
    const password = passRef.current.value;

    if (!phoneNumber || !password) {
      setIsLoading(false);
      return toast.error("لطفا اطلاعات را وارد کنید");
    }

    if (isNaN(phoneNumber)) {
      setIsLoading(false);
      return toast.error("لطفا شماره ی درست را وارد کنید");
    }

    const data = {
      phone: phoneNumber,
      pass: password,
    };

    let response;
    try {
      response = await login(data);
    } catch (error) {
      toast.error(error);
      setIsLoading(false);
      return;
    }
    setIsLoading(false);

    navigate("/");
  }

  return (
    <div className="log_sign-background">
      <div className="log_sign-container">
        <Link to="/">
          <div className="close-button popup-mode-close">
            <FontAwesomeIcon icon={faArrowLeft} />
          </div>
        </Link>
        <div className="log_sign-popup">
          <form action="" className="log_sign-form" onSubmit={handleLogin}>
            <div className="goto-signup">
              <Link to="/signup">هنوز ثبت نام نکرده ام...</Link>
            </div>
            <InputBox
              name="sign-tel"
              label="شماره موبایل"
              type="text"
              ref={phoneRef}
              responsive={true}
            />
            <InputBox
              name="sign-pass"
              label="رمز عبور"
              type="password"
              ref={passRef}
              responsive={true}
            />
            <div className="forget-password">
              <Link to="/forget-password">فراموشی رمز عبور</Link>
            </div>
            <button
              className="log_sign-button red-submit-btn "
              disabled={isLoading}
            >
              {isLoading ? <Loader loading={isLoading} small dark /> : "ورود"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
